/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { compareTextDependencies } from './dependenciesCompareText.generated';
import { isZeroDependencies } from './dependenciesIsZero.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createEqualText } from '../../factoriesAny.js';
export var equalTextDependencies = {
  compareTextDependencies: compareTextDependencies,
  isZeroDependencies: isZeroDependencies,
  typedDependencies: typedDependencies,
  createEqualText: createEqualText
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesEqualText.generated.js
// module id = 1537
// module chunks = 0